/* eslint no-template-curly-in-string: 0 */
import subwayIcon from '../../assets/images/subwayLogo.png';
import { PAYMENT_NETWORKS } from "../../utils/enums";

export const subway = {
  id: PAYMENT_NETWORKS.EGIFT_BLACKHAWK_SUBWAY,
  displayName: "Subway™",
  paywall: {
    tile: {
      displayName: "Subway™",
      tagline: "Your favorite fresh sandwiches",
      logo: subwayIcon
    },
    disabledPaymentNetwork: {
      title: 'Endpoint Not Live',
      description: 'For this trial program, ${paymentNetwork.displayName} is only listed as an example of the 250+ options DigitalPay currently offers.  Click the button below to go back and select a live network. Live networks are not “grayed out.”'
    },
  },
};

export default subway;
